
/*
 *   File : user-summary.js
 *   Author URI : https://evoqins.com
 *   Description : User summary card
 *   Integrations : null
 *   Version : v1.1
 */

/*import packages*/
import { Fragment, React, useState } from "react";
import Colors from "../../Styles/color.module.scss";

const SUMMARY_CARD_DEFAULT_SHADOW = "0px 1px 3px 0px rgba(50, 50, 71, 0.08)";

const UserSummary = (props) => {
    const [showUnitsHeld, setShowUnitsHeld] = useState(false);
    const [isCardHovered, setIsCardHovered] = useState(false);
    const hasTooltip = Boolean(props.tooltip);
    // hover visuals only make sense when the card is actually clickable
    const isHoverActive = isCardHovered && Boolean(props.onClick);

    const _showUnitsHeld = () => {
        setShowUnitsHeld(!showUnitsHeld);
    }

    // hover applies to every card; tooltip visibility stays gated by hasTooltip below
    const _handleCardEnter = () => {
        setIsCardHovered(true);
    }

    const _handleCardLeave = () => {
        setIsCardHovered(false);
    }

    return (
        <Fragment>
            {
                props.type === 1 ?
                    <div className={`border-radius-16px padding-24px-all w-100 h-100 ${props.borderColor ? props.borderColor : "bg-pale-steel-blue"}`}>
                        <div className="d-flex align-items-center justify-content-between ">
                            <span className="e-poppins-medium e-font-14 line-height-20px color-outer-space capitalized-text">{props.title}</span>

                            <img draggable={false} src={props.icon}
                                alt="User info"
                                width={40}
                                height={40}
                            />
                        </div>
                        <h6 className="e-poppins-bold e-font-24 line-height-36px color-black mt-0 mb-0">
                            {props.count}
                        </h6>

                    </div>
                    :
                    props.type === 2 ?
                        <div className="border-radius-16px bg-white padding-24px-all w-100">
                            <div className="d-flex align-items-center justify-content-between ">
                                <span className="e-poppins-medium e-font-14 line-height-20px color-outer-space capitalized-text">
                                    {props.title}
                                </span>

                                <img draggable={false} src={props.icon}
                                    alt="Orders"
                                    width={40}
                                    height={40}
                                />
                            </div>

                            <h6 className="e-poppins-bold e-font-24 line-height-36px color-black mt-0 mb-0 position-relative cursor-pointer"
                                onMouseEnter={_showUnitsHeld}
                                onMouseLeave={_showUnitsHeld}>
                                <span className="e-inter-bold">₹</span>
                                {props.count_text}
                                {
                                    showUnitsHeld &&
                                    <p className="border-radius-8px border-all border-bright-gray position-absolute color-jett-black e-poppins-regular e-font-14 line-height-12px p-2 bg-white mt-0">
                                        <span className="e-inter-regular pe-1">₹</span>
                                        {props.count.toLocaleString('en-IN')}
                                    </p>
                                }
                            </h6>

                        </div>
                        :
                        props.type === 4 ?
                            <div className={`border-radius-8px padding-12px-all w-100 h-100 bg-white d-flex flex-column justify-content-between ${props.onClick ? "cursor-pointer" : ""}`}
                                style={{
                                    position: "relative",
                                    minHeight: "88px",
                                    borderWidth: "1px",
                                    borderStyle: "solid",
                                    // toggle only the 3 non-bottom sides on hover — using the borderColor
                                    // shorthand here would reset the bottom too (React won't re-apply the
                                    // unchanged borderBottomColor), wiping the accent after mouse-leave
                                    borderTopColor: (isHoverActive || props.isActive) ? props.borderBottomColor : Colors.bright_gray,
                                    borderRightColor: (isHoverActive || props.isActive) ? props.borderBottomColor : Colors.bright_gray,
                                    borderLeftColor: (isHoverActive || props.isActive) ? props.borderBottomColor : Colors.bright_gray,
                                    borderBottomWidth: "4px",
                                    borderBottomColor: props.borderBottomColor,
                                    borderBottomStyle: "solid",
                                    boxShadow: (isHoverActive || props.isActive) ? `0px 4px 16px ${props.borderBottomColor}33` : SUMMARY_CARD_DEFAULT_SHADOW,
                                    zIndex: isHoverActive ? 20 : "auto",
                                    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                                }}
                                onClick={props.onClick}
                                onMouseEnter={_handleCardEnter}
                                onMouseLeave={_handleCardLeave}>
                                {
                                    hasTooltip &&
                                    <div
                                        aria-hidden={!isHoverActive}
                                        style={{
                                            position: "absolute",
                                            top: "8px",
                                            left: "12px",
                                            zIndex: 2,
                                            opacity: isHoverActive ? 1 : 0,
                                            visibility: isHoverActive ? "visible" : "hidden",
                                            transition: "opacity 0.2s ease",
                                            pointerEvents: "none",
                                        }}>
                                        <p className="e-poppins-regular e-font-12 line-height-16px mb-0 white-space-nowrap"
                                            style={{
                                                backgroundColor: "#4B5563",
                                                color: "#FFFFFF",
                                                borderRadius: "8px",
                                                padding: "6px 12px",
                                            }}>
                                            {props.tooltip}
                                        </p>
                                    </div>
                                }
                                <span className="e-poppins-regular e-font-14 line-height-20px color-outer-space white-space-nowrap">{props.title}</span>
                                <h6 className="e-poppins-bold e-font-24 line-height-36px mt-2 mb-0"
                                    style={{ color: props.countColor || Colors.black }}>
                                    {props.count}
                                </h6>
                            </div>
                            :
                            <div className={`border-radius-16px  padding-24px-all w-100 h-100 ${props.borderColor ? props.borderColor : "bg-pale-steel-blue"}`}>
                                <div className="d-flex align-items-center justify-content-between ">
                                    <span className="e-poppins-medium e-font-14 line-height-20px color-outer-space">{props.title}</span>

                                    <img draggable={false} src={props.icon}
                                        alt="User info"
                                        width={40}
                                        height={40}
                                    />
                                </div>
                                <h6 className="e-poppins-bold e-font-24 line-height-36px color-black mt-2 mb-0">
                                    {props.count}
                                </h6>

                            </div>
            }
        </Fragment>
    )
}

UserSummary.defaultProps = {
    count: 0,
    count_text: "0",
    title: "",
    icon: null,
    type: 1,
    isActive: false
}

export default UserSummary;

